import type { ModelsNews } from '@/api/generated-api'

export type NewsTagFilter = 'all' | string

/** The label of the article's first tag, in the reader's language when one exists. */
export function getPrimaryNewsTagLabel(
  news: Pick<ModelsNews, 'tags' | 'tag_labels'>
): string | undefined {
  const tag = news.tags?.find(tag => tag.trim().length > 0)
  if (!tag) return undefined
  return news.tag_labels?.[tag] || tag
}
